import reducer from './reducers';

import * as labActions from './actions';

export {
  labActions,
};

export default reducer;
